import { createFileRoute } from '@tanstack/react-router';
import { AuthProvider } from 'src/features/auth/contexts/AuthContext';
import EnableMfa from 'src/features/auth/components/EnableMfa';

export const Route = createFileRoute('/_auth/enable-mfa')({
  head: () => ({
    meta: [{ title: 'Enable MFA | Tekst' }],
  }),
  component: EnableMfaPage,
});

function EnableMfaPage() {
  return (
    <AuthProvider>
      <EnableMfa redirectUrl="/login" dashboardUrl="/" className="w-[400px]" />
    </AuthProvider>
  );
}
